import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    AnalyticsPeople,
    CoverageHistory,
    UserActivityCounts,
} from 'src/domain/analytics';
import { CoverageCard } from './CoverageCard';
import { ActiveCoverageCard, ActiveUsersCard } from './UserActivitySummary';
import { useAnalyticsSupportDrilldown } from './useAnalyticsSupportDrilldown';

export const TrackedActivitySection = ({
    usage,
    organizations,
    employees,
    residents,
    history,
    loading,
    error,
    departmentFiltered = false,
}: {
    usage?: UserActivityCounts;
    organizations: AnalyticsPeople['organizations'];
    employees: number;
    residents: number;
    history?: CoverageHistory;
    loading: boolean;
    error?: unknown;
    departmentFiltered?: boolean;
}) => {
    const { t } = useTranslation();
    const drilldown = useAnalyticsSupportDrilldown(organizations);
    return (
        <details className="analytics-tracked-activity" open>
            <summary>
                <span>{t('admin.analytics.trackedActivityTitle')}</span>
                <ChevronDown size={18} aria-hidden="true" />
            </summary>
            <div className="analytics-people-groups analytics-tracked-groups">
                <div className="analytics-people-group analytics-staff-group">
                    <CoverageCard
                        population="employees"
                        usage={usage}
                        total={employees}
                        history={history}
                        loading={loading}
                        error={error}
                    />
                    {usage && (
                        <ActiveUsersCard usage={usage} role="employees" />
                    )}
                </div>
                <div className="analytics-people-group analytics-resident-group bg-lightBlue">
                    <CoverageCard
                        population="residents"
                        onNeverLoggedIn={
                            !departmentFiltered && drilldown.canOpen
                                ? () => drilldown.open('residents')
                                : undefined
                        }
                        usage={usage}
                        total={residents}
                        history={history}
                        loading={loading}
                        error={error}
                    />
                    {usage && (
                        <ActiveUsersCard usage={usage} role="mainContacts" />
                    )}
                    {usage && (
                        <ActiveCoverageCard
                            usage={usage}
                            residents={residents}
                        />
                    )}
                </div>
            </div>
            {drilldown.chooser}
        </details>
    );
};
